<template>
  <input autocomplete="off" :readonly="forprint" class="rx-input" :name="name" ref="input" v-validate="myValidation" v-bind:value="value" v-on:input="updateValue($event.target.value)" v-on:focus="selectAllAndSaveValue" v-on:blur="formatValue(decimalEnabled)">
</template>

<script>
var fieldValidator = {
  format: function(number, precision) {
    return (Math.trunc(number * 1000000000000) / 1000000000000).toFixed(
      precision
    );
  }
};

function empty(testValue) {
  return (
    testValue === null ||
    testValue === undefined ||
    (typeof testValue == "string" && testValue.trim() === "")
  );
}

export default {
  inject: ["$validator"],
  props: {
    value: {},
    label: {
      type: String,
      default: ""
    },
    precision: {
      type: Number,
      default: 1
    },
    name: {
      type: String
    },
    useSign: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    required: {
      type: Boolean,
      default: false
    },
    forprint: {
      type: Boolean,
      default: false
    },
    decimalEnabled: {
      type: Boolean,
      default: true // Default to true for decimal formatting
    }
  },
  data() {
    return {
      previousValue: null,
      proposedValue: null
    };
  },
  mounted: function() {
    this.saveValue();
    this.proposedValue = this.value;
    // this.formatValue();
  },
  computed: {
    myValidation() {
      var result = "";
      if (this.required) {
        result += "|required";
      }
      if (this.max != null) {
        result += "|max_value:" + this.max;
      }
      if (this.min != null) {
        result += "|min_value:" + this.min;
      }

      return result;
    }
  },
  methods: {
    emitChange(newValue) {
      var result = { value: newValue };
      this.$refs.input.value = result.value;
      this.$emit("input", result.value);
    },
    updateValue: function(value) {
      this.proposedValue = value;
    },
    formatValue: function(decimalEnabled) {
      if (empty(this.proposedValue)) {
        this.emitChange(null);
        return;
      }

      let strVal = String(this.proposedValue);
      var temp = strVal.trim();
      let signed = temp[0] == "-" || temp[0] === "+";
      if (signed && !this.useSign) {
        temp = temp.substring(1);
      }

      if (isNaN(temp)) {
        this.emitChange(this.previousValue);
        return;
      }

      let formattedValue;

      if (decimalEnabled) {
        formattedValue = parseFloat(temp).toFixed(this.precision); // Ensure fixed precision
        if (formattedValue > 0 && this.useSign) {
          formattedValue = "+" + formattedValue;
        }
      } else {
        // If decimal is not enabled, round the value to the nearest integer
        formattedValue = Math.round(parseFloat(temp));
        if (this.useSign) {
          if (formattedValue >= 0) {
            formattedValue = "+" + formattedValue;
          }
        }
      }
      this.emitChange(formattedValue);
    },
    saveValue() {
      this.previousValue = this.value;
    },
    selectAllAndSaveValue: function(event) {
      this.saveValue();
      event.target.select();
    }
  }
};
</script>

<style>
.rx-input {
  font-size: 10pt;
  display: table-cell;
  width: 100%;
  height: 100%;
  margin: 0;
  border: none;
}
</style>
